/** A child's profile, and its Sharing tab (ChildDetail reads `?tab=`). */
export function childProfileHref(childId: string): string {
  return `/child/${encodeURIComponent(childId)}`;
}

export function childShareHref(childId: string): string {
  return `${childProfileHref(childId)}?tab=sharing`;
}
